import React from "react";
import { Route, Routes } from "react-router-dom";
import JobErros from "../pages/jobs/JobErros";
import QuotationList from "../pages/quotations/QuotationList";
import QuotationCreate from "../pages/quotations/QuotationCreate";
import QuotationToPdf from "../pages/quotations/QuotationToPdf";

export default function QuotationRoutes() {
  return (
    <Routes>
      <Route path="" element={<QuotationList />} />
      <Route path="/createQuotation" element={<QuotationCreate />} />
      <Route path="/:quotation/quotationToPdf" element={<QuotationToPdf />} />
      <Route path="/:quotation/edit" element={<QuotationCreate />} />

      <Route path="/errors" element={<JobErros />} />
    </Routes>
  );
}
